"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _Spacer = _interopRequireDefault(require("../Spacer"));

var _Stack = _interopRequireDefault(require("../Stack"));

var _Typography = _interopRequireDefault(require("../Typography"));

var _ButtonStyles = require("./Button-styles");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function detectNormalButton({
  outline,
  fill
}) {
  if (outline) {
    return `${outline}.main`;
  } else if (fill === "white") {
    return "primary.main";
  } else if (fill) {
    return "common.white";
  }

  return;
}

function detectDisabledButton({
  disabled,
  outline,
  fill
}) {
  if (disabled && outline) {
    return "neutrals.300";
  } else if (disabled && fill === "white") {
    return "neutrals.300";
  } else if (disabled && fill) {
    return "common.white";
  } else if (disabled) {
    return "common.white";
  }

  return;
}

function detectTextColor({
  outline,
  fill,
  disabled
}, defaultTextColor) {
  if (disabled) {
    return detectDisabledButton({
      outline,
      fill,
      disabled
    });
  } else {
    return defaultTextColor || detectNormalButton({
      outline,
      fill
    });
  }
}

function Button(props) {
  let {
    children,
    onPress,
    size = "m",
    // @ts-ignore farzad will fix
    fill,
    // @ts-ignore farzad will fix
    outline,
    disabled,
    textColor,
    fs = "m",
    radius,
    ...styleProps
  } = props;

  if (!outline && !fill) {
    fill = "primary";
  }

  if (fill && typeof fill === "boolean") {
    fill = "primary";
  }

  if (outline && typeof outline === "boolean") {
    outline = "primary";
  }

  if (fill === "white") {
    fill = "white";
  }

  return /*#__PURE__*/_react.default.createElement(_ButtonStyles.Button, _extends({
    fill: fill,
    outline: outline,
    size: size,
    disabled: disabled,
    onPress: onPress,
    radius: radius
  }, styleProps), /*#__PURE__*/_react.default.createElement(_Stack.default, {
    distribution: "center"
  }, props.prefix, props.prefix ? /*#__PURE__*/_react.default.createElement(_Spacer.default, {
    size: "s"
  }) : null, /*#__PURE__*/_react.default.createElement(_Typography.default, {
    alignment: "center",
    ff: "mainBold",
    fs: fs,
    color: detectTextColor({
      outline,
      fill,
      disabled
    }, textColor)
  }, props.children), props.suffix ? /*#__PURE__*/_react.default.createElement(_Spacer.default, {
    size: "s"
  }) : null, props.suffix));
}

var _default = Button;
exports.default = _default;